/**
 * @prettier
 * @flow
 */
export const TerminalInstructionReceivedResults = Object.freeze({
    UNKNOWN: 'UNKNOWN',
    TERMINAL_BUSY: 'TERMINAL_BUSY',
    TERMINAL_NOT_FOUND: 'TERMINAL_NOT_FOUND',
    INSTRUCTION_RECEIVED: 'INSTRUCTION_RECEIVED',
});

export type TerminalInstructionReceivedResult = $Values<typeof TerminalInstructionReceivedResults>;
